//Reset data
export const RESET = "MESSAGE_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "MESSAGE_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "MESSAGE_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "MESSAGE_LIST_SET_HIDE_LOADING"

//Pagination
export const SET_PAGINATION = "MESSAGE_LIST_SET_PAGINATION"

//Message
export const SET_MESSAGE = "MESSAGE_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "MESSAGE_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "MESSAGE_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "MESSAGE_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "MESSAGE_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "MESSAGE_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "MESSAGE_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "MESSAGE_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "MESSAGE_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "MESSAGE_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "MESSAGE_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "MESSAGE_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "MESSAGE_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "MESSAGE_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "MESSAGE_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "MESSAGE_LIST_SET_MODAL_TYPE"